import { useEffect, useState, useRef } from 'react';
export default function useFilterFixed({
  scrollBody,
  hideTop = 200,
  minHeight,
  filterHeight, // 吸顶筛选器高度
  filterSearchHeight, // 吸顶搜索框高度
}: {
  scrollBody?: React.MutableRefObject<any>;
  hideTop?: number;
  minHeight?: number;
  filterHeight: number;
  filterSearchHeight: number;
}) {
  const [filterSearchFixed, setFilterSearchFixed] = useState(false);
  const [filterFixed, setFilterFixed] = useState(false);

  useEffect(() => {
    const handleScroll = (event: any) => {
      if (event.target === scrollBody?.current) {
        const { scrollTop } = event.srcElement;
        // 滚动达到搜索框高度
        if (scrollTop > filterSearchHeight) {
          setFilterSearchFixed(true);
        } else {
          setFilterSearchFixed(false);
        }
        const scrollTopValue = scrollTop + 20;
        // 滚动达到筛选器高度
        if (scrollTopValue > filterHeight) {
          setFilterFixed(true);
        } else {
          setFilterFixed(false);
        }
      }
    };
    if (scrollBody?.current) {
      scrollBody.current?.addEventListener('scroll', handleScroll, true);
      return () => scrollBody.current?.removeEventListener('scroll', handleScroll, true);
    }
  }, [hideTop, minHeight, scrollBody]);

  return { filterFixed, filterSearchFixed };
}
